export function Lightning() {
  return (
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9023 2.84156C14.0533 1.63343 12.517 0.99434 11.7666 1.95315L3.46523 12.5605C2.84877 13.3482 3.40999 14.5 4.41024 14.5H10.3752L9.58902 21.1826C9.44771 22.3837 10.971 23.0159 11.7217 22.0676L20.5272 10.9449C21.15 10.1582 20.5897 9.00002 19.5863 9.00002H13.1325L13.9023 2.84156Z" fill="currentColor"/>
</svg>
  );
}